import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const session = localStorage.getItem("session_id");

  if (!session) {
    return <Navigate to="/signup" replace />;
  }

  return children;
};

export default ProtectedRoute;